// AUTO-GENERATED tutorial teaching scenarios — sanitized captures of the
// REAL backend rules/positioning engine driven locally in the backend test
// environment (deterministic deals; search seeds: domino=4, blocked=19,
// matchwin=4 with preset team scores 95-88). Payloads are the authentic
// game_state_for_user / game_finished broadcast shapes. Sanitized exactly
// like tutorialFixtures.ts (synthetic ids, value-based tile ids, wall-clock
// stripped). Do NOT hand-edit geometry — regenerate from a fresh capture.
import type { FullGameStateForUser, GameState, RematchSnapshotWire, RevealedPlayer } from '../../types/game';

/** The captured game_finished broadcast, minus the 'type' tag. */
export interface FinishedFixture {
  game_state: GameState;
  team_scores: Record<string, number>;
  session_status: string;
  session_winner_team: number | null;
  session_over: boolean;
  target_score: number;
  rematch: RematchSnapshotWire | null;
  revealed_players: RevealedPlayer[];
}

export interface ScenarioFixture {
  gameId: number;
  boot: FullGameStateForUser;
  /** Post-action state (double / pass scenarios). */
  after?: FullGameStateForUser;
  /** Round-ending broadcast (domino / blocked / matchwin scenarios). */
  finished?: FinishedFixture;
}

/** Per-scenario tile-id namespaces: the board diff-renderer keeps a retained
 *  id's old position, so scenario swaps must never reuse ids — distinct
 *  bases make every swap a clean remove-and-rebuild. */
export const SCENARIO_TILE_BASE = {
  double: 1100, pass: 1200, domino: 1300, blocked: 1400, matchwin: 1500,
} as const;

export const scenarioTileId = (
  scenario: keyof typeof SCENARIO_TILE_BASE, a: number, b: number,
): number => SCENARIO_TILE_BASE[scenario] + Math.max(a, b) * 7 + Math.min(a, b);

export const TUTORIAL_SCENARIOS: Record<
  'double' | 'pass' | 'domino' | 'blocked' | 'matchwin',
  ScenarioFixture
> = {
  "double": {
    "gameId": 9003,
    "boot": {
      "id": 9003,
      "state_seq": 3,
      "status": "active",
      "game_mode": "bots",
      "current_turn": 0,
      "current_turn_user_id": 101,
      "current_turn_team": 0,
      "board_left_end": 4,
      "board_right_end": 1,
      "played_tiles": [],
      "my_hand": [
        {
          "id": 1132,
          "value_a": 4,
          "value_b": 4,
          "is_double": true,
          "valid_positions": [
            {
              "side": "left",
              "end_id": 4,
              "x": -3.0,
              "y": 0.0,
              "orientation": "vertical",
              "engine_data": {
                "a": 4,
                "b": 4,
                "ndir": "left",
                "near_val": 4,
                "far_val": 4,
                "double": true,
                "center": [
                  -3.0,
                  0.0
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            }
          ]
        },
        {
          "id": 1100,
          "value_a": 0,
          "value_b": 0,
          "is_double": true,
          "valid_positions": []
        },
        {
          "id": 1114,
          "value_a": 2,
          "value_b": 0,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 1123,
          "value_a": 3,
          "value_b": 2,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 1138,
          "value_a": 5,
          "value_b": 3,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 1135,
          "value_a": 5,
          "value_b": 0,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 1137,
          "value_a": 5,
          "value_b": 2,
          "is_double": false,
          "valid_positions": []
        }
      ],
      "my_team": 0,
      "my_position": 0,
      "viewer_cosmetics": {
        "table_skin": "green_fabric",
        "tile_skin": "classic"
      },
      "winner_team": null,
      "game_end_type": null,
      "session_id": 9002,
      "game_number": 1,
      "starting_player_position": 1,
      "starting_player_user_id": 102,
      "board_layout": {
        "board_config": {
          "min_x": -6,
          "max_x": 6,
          "min_y": -7,
          "max_y": 7,
          "tile_width": 2,
          "tile_height": 1
        },
        "tiles": [
          {
            "id": 1148,
            "value_a": 6,
            "value_b": 6,
            "position": {
              "x": 0.0,
              "y": 0.0,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 6,
              "ndir": "right",
              "near_val": 6,
              "far_val": 6,
              "double": false,
              "center": [
                0.0,
                0.0
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1146,
            "value_a": 6,
            "value_b": 4,
            "position": {
              "x": -1.5,
              "y": 0.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 4,
              "ndir": "left",
              "near_val": 6,
              "far_val": 4,
              "double": false,
              "center": [
                -1.5,
                0.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1143,
            "value_a": 6,
            "value_b": 1,
            "position": {
              "x": 1.5,
              "y": 0.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 1,
              "ndir": "right",
              "near_val": 6,
              "far_val": 1,
              "double": false,
              "center": [
                1.5,
                0.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          }
        ],
        "board_ends": [],
        "chain_length": 3
      },
      "board_chain_length": 3,
      "players": [
        {
          "id": 101,
          "display_name": "You",
          "country_code": null,
          "avatar_key": null,
          "avatar_url": null,
          "is_bot": false,
          "team": 0,
          "position": 0
        },
        {
          "id": 102,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_1",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 1
        },
        {
          "id": 103,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_2",
          "avatar_url": null,
          "is_bot": true,
          "team": 0,
          "position": 2
        },
        {
          "id": 104,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_3",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 3
        }
      ],
      "hand_counts": {
        "0": 7,
        "1": 6,
        "2": 6,
        "3": 6
      },
      "session_team_scores": {
        "0": 0,
        "1": 0
      },
      "next_round_ready": null,
      "next_game_id": null,
      "session_over": false,
      "session_winner_team": null,
      "session_completion_reason": null,
      "target_score": 100,
      "rematch": null
    },
    "after": {
      "id": 9003,
      "state_seq": 4,
      "status": "active",
      "game_mode": "bots",
      "current_turn": 1,
      "current_turn_user_id": 102,
      "current_turn_team": 1,
      "board_left_end": 4,
      "board_right_end": 1,
      "played_tiles": [],
      "my_hand": [
        {
          "id": 1100,
          "value_a": 0,
          "value_b": 0,
          "is_double": true,
          "valid_positions": []
        },
        {
          "id": 1114,
          "value_a": 2,
          "value_b": 0,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 1123,
          "value_a": 3,
          "value_b": 2,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 1138,
          "value_a": 5,
          "value_b": 3,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 1135,
          "value_a": 5,
          "value_b": 0,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 1137,
          "value_a": 5,
          "value_b": 2,
          "is_double": false,
          "valid_positions": []
        }
      ],
      "my_team": 0,
      "my_position": 0,
      "viewer_cosmetics": {
        "table_skin": "green_fabric",
        "tile_skin": "classic"
      },
      "winner_team": null,
      "game_end_type": null,
      "session_id": 9002,
      "game_number": 1,
      "starting_player_position": 1,
      "starting_player_user_id": 102,
      "board_layout": {
        "board_config": {
          "min_x": -6,
          "max_x": 6,
          "min_y": -7,
          "max_y": 7,
          "tile_width": 2,
          "tile_height": 1
        },
        "tiles": [
          {
            "id": 1148,
            "value_a": 6,
            "value_b": 6,
            "position": {
              "x": 0.0,
              "y": 0.0,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 6,
              "ndir": "right",
              "near_val": 6,
              "far_val": 6,
              "double": false,
              "center": [
                0.0,
                0.0
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1146,
            "value_a": 6,
            "value_b": 4,
            "position": {
              "x": -1.5,
              "y": 0.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 4,
              "ndir": "left",
              "near_val": 6,
              "far_val": 4,
              "double": false,
              "center": [
                -1.5,
                0.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1143,
            "value_a": 6,
            "value_b": 1,
            "position": {
              "x": 1.5,
              "y": 0.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 1,
              "ndir": "right",
              "near_val": 6,
              "far_val": 1,
              "double": false,
              "center": [
                1.5,
                0.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1132,
            "value_a": 4,
            "value_b": 4,
            "position": {
              "x": -3.0,
              "y": 0.0,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 4,
              "b": 4,
              "ndir": "left",
              "near_val": 4,
              "far_val": 4,
              "double": false,
              "center": [
                -3.0,
                0.0
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          }
        ],
        "board_ends": [],
        "chain_length": 4
      },
      "board_chain_length": 4,
      "players": [
        {
          "id": 101,
          "display_name": "You",
          "country_code": null,
          "avatar_key": null,
          "avatar_url": null,
          "is_bot": false,
          "team": 0,
          "position": 0
        },
        {
          "id": 102,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_1",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 1
        },
        {
          "id": 103,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_2",
          "avatar_url": null,
          "is_bot": true,
          "team": 0,
          "position": 2
        },
        {
          "id": 104,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_3",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 3
        }
      ],
      "hand_counts": {
        "0": 6,
        "1": 6,
        "2": 6,
        "3": 6
      },
      "session_team_scores": {
        "0": 0,
        "1": 0
      },
      "next_round_ready": null,
      "next_game_id": null,
      "session_over": false,
      "session_winner_team": null,
      "session_completion_reason": null,
      "target_score": 100,
      "rematch": null
    }
  },
  "pass": {
    "gameId": 9004,
    "boot": {
      "id": 9004,
      "state_seq": 3,
      "status": "active",
      "game_mode": "bots",
      "current_turn": 0,
      "current_turn_user_id": 101,
      "current_turn_team": 0,
      "board_left_end": 3,
      "board_right_end": 2,
      "played_tiles": [],
      "my_hand": [
        {
          "id": 1200,
          "value_a": 0,
          "value_b": 0,
          "is_double": true,
          "valid_positions": []
        },
        {
          "id": 1207,
          "value_a": 1,
          "value_b": 0,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 1208,
          "value_a": 1,
          "value_b": 1,
          "is_double": true,
          "valid_positions": []
        },
        {
          "id": 1232,
          "value_a": 4,
          "value_b": 4,
          "is_double": true,
          "valid_positions": []
        },
        {
          "id": 1239,
          "value_a": 5,
          "value_b": 4,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 1240,
          "value_a": 5,
          "value_b": 5,
          "is_double": true,
          "valid_positions": []
        },
        {
          "id": 1228,
          "value_a": 4,
          "value_b": 0,
          "is_double": false,
          "valid_positions": []
        }
      ],
      "my_team": 0,
      "my_position": 0,
      "viewer_cosmetics": {
        "table_skin": "green_fabric",
        "tile_skin": "classic"
      },
      "winner_team": null,
      "game_end_type": null,
      "session_id": 9002,
      "game_number": 1,
      "starting_player_position": 1,
      "starting_player_user_id": 102,
      "board_layout": {
        "board_config": {
          "min_x": -6,
          "max_x": 6,
          "min_y": -7,
          "max_y": 7,
          "tile_width": 2,
          "tile_height": 1
        },
        "tiles": [
          {
            "id": 1248,
            "value_a": 6,
            "value_b": 6,
            "position": {
              "x": 0.0,
              "y": 0.0,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 6,
              "ndir": "right",
              "near_val": 6,
              "far_val": 6,
              "double": false,
              "center": [
                0.0,
                0.0
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1245,
            "value_a": 6,
            "value_b": 3,
            "position": {
              "x": -1.5,
              "y": 0.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 3,
              "ndir": "left",
              "near_val": 6,
              "far_val": 3,
              "double": false,
              "center": [
                -1.5,
                0.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1244,
            "value_a": 6,
            "value_b": 2,
            "position": {
              "x": 1.5,
              "y": 0.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 2,
              "ndir": "right",
              "near_val": 6,
              "far_val": 2,
              "double": false,
              "center": [
                1.5,
                0.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          }
        ],
        "board_ends": [],
        "chain_length": 3
      },
      "board_chain_length": 3,
      "players": [
        {
          "id": 101,
          "display_name": "You",
          "country_code": null,
          "avatar_key": null,
          "avatar_url": null,
          "is_bot": false,
          "team": 0,
          "position": 0
        },
        {
          "id": 102,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_1",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 1
        },
        {
          "id": 103,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_2",
          "avatar_url": null,
          "is_bot": true,
          "team": 0,
          "position": 2
        },
        {
          "id": 104,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_3",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 3
        }
      ],
      "hand_counts": {
        "0": 7,
        "1": 6,
        "2": 6,
        "3": 6
      },
      "session_team_scores": {
        "0": 0,
        "1": 0
      },
      "next_round_ready": null,
      "next_game_id": null,
      "session_over": false,
      "session_winner_team": null,
      "session_completion_reason": null,
      "target_score": 100,
      "rematch": null
    },
    "after": {
      "id": 9004,
      "state_seq": 4,
      "status": "active",
      "game_mode": "bots",
      "current_turn": 1,
      "current_turn_user_id": 102,
      "current_turn_team": 1,
      "board_left_end": 3,
      "board_right_end": 2,
      "played_tiles": [],
      "my_hand": [
        {
          "id": 1200,
          "value_a": 0,
          "value_b": 0,
          "is_double": true,
          "valid_positions": []
        },
        {
          "id": 1207,
          "value_a": 1,
          "value_b": 0,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 1208,
          "value_a": 1,
          "value_b": 1,
          "is_double": true,
          "valid_positions": []
        },
        {
          "id": 1232,
          "value_a": 4,
          "value_b": 4,
          "is_double": true,
          "valid_positions": []
        },
        {
          "id": 1239,
          "value_a": 5,
          "value_b": 4,
          "is_double": false,
          "valid_positions": []
        },
        {
          "id": 1240,
          "value_a": 5,
          "value_b": 5,
          "is_double": true,
          "valid_positions": []
        },
        {
          "id": 1228,
          "value_a": 4,
          "value_b": 0,
          "is_double": false,
          "valid_positions": []
        }
      ],
      "my_team": 0,
      "my_position": 0,
      "viewer_cosmetics": {
        "table_skin": "green_fabric",
        "tile_skin": "classic"
      },
      "winner_team": null,
      "game_end_type": null,
      "session_id": 9002,
      "game_number": 1,
      "starting_player_position": 1,
      "starting_player_user_id": 102,
      "board_layout": {
        "board_config": {
          "min_x": -6,
          "max_x": 6,
          "min_y": -7,
          "max_y": 7,
          "tile_width": 2,
          "tile_height": 1
        },
        "tiles": [
          {
            "id": 1248,
            "value_a": 6,
            "value_b": 6,
            "position": {
              "x": 0.0,
              "y": 0.0,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 6,
              "ndir": "right",
              "near_val": 6,
              "far_val": 6,
              "double": false,
              "center": [
                0.0,
                0.0
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1245,
            "value_a": 6,
            "value_b": 3,
            "position": {
              "x": -1.5,
              "y": 0.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 3,
              "ndir": "left",
              "near_val": 6,
              "far_val": 3,
              "double": false,
              "center": [
                -1.5,
                0.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1244,
            "value_a": 6,
            "value_b": 2,
            "position": {
              "x": 1.5,
              "y": 0.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 2,
              "ndir": "right",
              "near_val": 6,
              "far_val": 2,
              "double": false,
              "center": [
                1.5,
                0.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          }
        ],
        "board_ends": [],
        "chain_length": 3
      },
      "board_chain_length": 3,
      "players": [
        {
          "id": 101,
          "display_name": "You",
          "country_code": null,
          "avatar_key": null,
          "avatar_url": null,
          "is_bot": false,
          "team": 0,
          "position": 0
        },
        {
          "id": 102,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_1",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 1
        },
        {
          "id": 103,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_2",
          "avatar_url": null,
          "is_bot": true,
          "team": 0,
          "position": 2
        },
        {
          "id": 104,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_3",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 3
        }
      ],
      "hand_counts": {
        "0": 7,
        "1": 6,
        "2": 6,
        "3": 6
      },
      "session_team_scores": {
        "0": 0,
        "1": 0
      },
      "next_round_ready": null,
      "next_game_id": null,
      "session_over": false,
      "session_winner_team": null,
      "session_completion_reason": null,
      "target_score": 100,
      "rematch": null
    }
  },
  "domino": {
    "gameId": 9005,
    "boot": {
      "id": 9005,
      "state_seq": 24,
      "status": "active",
      "game_mode": "bots",
      "current_turn": 0,
      "current_turn_user_id": 101,
      "current_turn_team": 0,
      "board_left_end": 5,
      "board_right_end": 0,
      "played_tiles": [],
      "my_hand": [
        {
          "id": 1340,
          "value_a": 5,
          "value_b": 5,
          "is_double": true,
          "valid_positions": [
            {
              "side": "left",
              "end_id": 22,
              "x": -6.0,
              "y": 5.0,
              "orientation": "horizontal",
              "engine_data": {
                "a": 5,
                "b": 5,
                "ndir": "up",
                "near_val": 5,
                "far_val": 5,
                "double": true,
                "center": [
                  -6.0,
                  5.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            }
          ]
        }
      ],
      "my_team": 0,
      "my_position": 0,
      "viewer_cosmetics": {
        "table_skin": "green_fabric",
        "tile_skin": "classic"
      },
      "winner_team": null,
      "game_end_type": null,
      "session_id": 9002,
      "game_number": 1,
      "starting_player_position": 0,
      "starting_player_user_id": 101,
      "board_layout": {
        "board_config": {
          "min_x": -6,
          "max_x": 6,
          "min_y": -7,
          "max_y": 7,
          "tile_width": 2,
          "tile_height": 1
        },
        "tiles": [
          {
            "id": 1348,
            "value_a": 6,
            "value_b": 6,
            "position": {
              "x": 0.0,
              "y": 0.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 6,
              "ndir": "right",
              "near_val": 6,
              "far_val": 6,
              "double": false,
              "center": [
                0.0,
                0.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1342,
            "value_a": 6,
            "value_b": 0,
            "position": {
              "x": 0.0,
              "y": -1.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 0,
              "ndir": "down",
              "near_val": 6,
              "far_val": 0,
              "double": false,
              "center": [
                0.0,
                -1.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1314,
            "value_a": 2,
            "value_b": 0,
            "position": {
              "x": 0.0,
              "y": -3.5,
              "orientation": "vertical",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 2,
              "b": 0,
              "ndir": "down",
              "near_val": 0,
              "far_val": 2,
              "double": false,
              "center": [
                0.0,
                -3.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1315,
            "value_a": 2,
            "value_b": 1,
            "position": {
              "x": 0.0,
              "y": -5.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 2,
              "b": 1,
              "ndir": "down",
              "near_val": 2,
              "far_val": 1,
              "double": false,
              "center": [
                0.0,
                -5.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1336,
            "value_a": 5,
            "value_b": 1,
            "position": {
              "x": -1.5,
              "y": -6.0,
              "orientation": "horizontal",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 5,
              "b": 1,
              "ndir": "left",
              "near_val": 1,
              "far_val": 5,
              "double": false,
              "center": [
                -1.5,
                -6.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1338,
            "value_a": 5,
            "value_b": 3,
            "position": {
              "x": -3.5,
              "y": -6.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 5,
              "b": 3,
              "ndir": "left",
              "near_val": 5,
              "far_val": 3,
              "double": false,
              "center": [
                -3.5,
                -6.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1345,
            "value_a": 6,
            "value_b": 3,
            "position": {
              "x": 0.0,
              "y": 1.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 3,
              "ndir": "up",
              "near_val": 6,
              "far_val": 3,
              "double": false,
              "center": [
                0.0,
                1.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1323,
            "value_a": 3,
            "value_b": 2,
            "position": {
              "x": -5.5,
              "y": -6.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 3,
              "b": 2,
              "ndir": "left",
              "near_val": 3,
              "far_val": 2,
              "double": false,
              "center": [
                -5.5,
                -6.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1331,
            "value_a": 4,
            "value_b": 3,
            "position": {
              "x": 0.0,
              "y": 3.5,
              "orientation": "vertical",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 4,
              "b": 3,
              "ndir": "up",
              "near_val": 3,
              "far_val": 4,
              "double": false,
              "center": [
                0.0,
                3.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1330,
            "value_a": 4,
            "value_b": 2,
            "position": {
              "x": -6.0,
              "y": -4.5,
              "orientation": "vertical",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 4,
              "b": 2,
              "ndir": "up",
              "near_val": 2,
              "far_val": 4,
              "double": false,
              "center": [
                -6.0,
                -4.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1328,
            "value_a": 4,
            "value_b": 0,
            "position": {
              "x": 0.0,
              "y": 5.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 4,
              "b": 0,
              "ndir": "up",
              "near_val": 4,
              "far_val": 0,
              "double": false,
              "center": [
                0.0,
                5.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1332,
            "value_a": 4,
            "value_b": 4,
            "position": {
              "x": -6.0,
              "y": -3.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 4,
              "b": 4,
              "ndir": "up",
              "near_val": 4,
              "far_val": 4,
              "double": false,
              "center": [
                -6.0,
                -3.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1346,
            "value_a": 6,
            "value_b": 4,
            "position": {
              "x": -6.0,
              "y": -1.5,
              "orientation": "vertical",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 4,
              "ndir": "up",
              "near_val": 4,
              "far_val": 6,
              "double": false,
              "center": [
                -6.0,
                -1.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1300,
            "value_a": 0,
            "value_b": 0,
            "position": {
              "x": 1.5,
              "y": 6.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 0,
              "b": 0,
              "ndir": "right",
              "near_val": 0,
              "far_val": 0,
              "double": false,
              "center": [
                1.5,
                6.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1307,
            "value_a": 1,
            "value_b": 0,
            "position": {
              "x": 3.5,
              "y": 6.0,
              "orientation": "horizontal",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 1,
              "b": 0,
              "ndir": "right",
              "near_val": 0,
              "far_val": 1,
              "double": false,
              "center": [
                3.5,
                6.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1344,
            "value_a": 6,
            "value_b": 2,
            "position": {
              "x": -6.0,
              "y": 0.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 2,
              "ndir": "up",
              "near_val": 6,
              "far_val": 2,
              "double": false,
              "center": [
                -6.0,
                0.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1329,
            "value_a": 4,
            "value_b": 1,
            "position": {
              "x": 5.5,
              "y": 6.0,
              "orientation": "horizontal",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 4,
              "b": 1,
              "ndir": "right",
              "near_val": 1,
              "far_val": 4,
              "double": false,
              "center": [
                5.5,
                6.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1316,
            "value_a": 2,
            "value_b": 2,
            "position": {
              "x": -6.0,
              "y": 2.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 2,
              "b": 2,
              "ndir": "up",
              "near_val": 2,
              "far_val": 2,
              "double": false,
              "center": [
                -6.0,
                2.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1339,
            "value_a": 5,
            "value_b": 4,
            "position": {
              "x": 6.0,
              "y": 4.5,
              "orientation": "vertical",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 5,
              "b": 4,
              "ndir": "down",
              "near_val": 4,
              "far_val": 5,
              "double": false,
              "center": [
                6.0,
                4.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1337,
            "value_a": 5,
            "value_b": 2,
            "position": {
              "x": -6.0,
              "y": 3.5,
              "orientation": "vertical",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 5,
              "b": 2,
              "ndir": "up",
              "near_val": 2,
              "far_val": 5,
              "double": false,
              "center": [
                -6.0,
                3.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1335,
            "value_a": 5,
            "value_b": 0,
            "position": {
              "x": 6.0,
              "y": 2.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 5,
              "b": 0,
              "ndir": "down",
              "near_val": 5,
              "far_val": 0,
              "double": false,
              "center": [
                6.0,
                2.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          }
        ],
        "board_ends": [],
        "chain_length": 21
      },
      "board_chain_length": 21,
      "players": [
        {
          "id": 101,
          "display_name": "You",
          "country_code": null,
          "avatar_key": null,
          "avatar_url": null,
          "is_bot": false,
          "team": 0,
          "position": 0
        },
        {
          "id": 102,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_1",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 1
        },
        {
          "id": 103,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_2",
          "avatar_url": null,
          "is_bot": true,
          "team": 0,
          "position": 2
        },
        {
          "id": 104,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_3",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 3
        }
      ],
      "hand_counts": {
        "0": 1,
        "1": 2,
        "2": 3,
        "3": 1
      },
      "session_team_scores": {
        "0": 0,
        "1": 0
      },
      "next_round_ready": null,
      "next_game_id": null,
      "session_over": false,
      "session_winner_team": null,
      "session_completion_reason": null,
      "target_score": 100,
      "rematch": null
    },
    "finished": {
      "game_state": {
        "id": 9005,
        "state_seq": 25,
        "status": "finished",
        "game_mode": "bots",
        "current_turn": 0,
        "current_turn_user_id": 101,
        "current_turn_team": 0,
        "board_left_end": 5,
        "board_right_end": 0,
        "played_tiles": [],
        "winner_team": 0,
        "game_end_type": "win",
        "session_id": 9002,
        "game_number": 1,
        "starting_player_position": 0,
        "starting_player_user_id": 101,
        "board_layout": {
          "board_config": {
            "min_x": -6,
            "max_x": 6,
            "min_y": -7,
            "max_y": 7,
            "tile_width": 2,
            "tile_height": 1
          },
          "tiles": [
            {
              "id": 1348,
              "value_a": 6,
              "value_b": 6,
              "position": {
                "x": 0.0,
                "y": 0.0,
                "orientation": "horizontal",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 6,
                "b": 6,
                "ndir": "right",
                "near_val": 6,
                "far_val": 6,
                "double": false,
                "center": [
                  0.0,
                  0.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1342,
              "value_a": 6,
              "value_b": 0,
              "position": {
                "x": 0.0,
                "y": -1.5,
                "orientation": "vertical",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 6,
                "b": 0,
                "ndir": "down",
                "near_val": 6,
                "far_val": 0,
                "double": false,
                "center": [
                  0.0,
                  -1.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1314,
              "value_a": 2,
              "value_b": 0,
              "position": {
                "x": 0.0,
                "y": -3.5,
                "orientation": "vertical",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 2,
                "b": 0,
                "ndir": "down",
                "near_val": 0,
                "far_val": 2,
                "double": false,
                "center": [
                  0.0,
                  -3.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1315,
              "value_a": 2,
              "value_b": 1,
              "position": {
                "x": 0.0,
                "y": -5.5,
                "orientation": "vertical",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 2,
                "b": 1,
                "ndir": "down",
                "near_val": 2,
                "far_val": 1,
                "double": false,
                "center": [
                  0.0,
                  -5.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1336,
              "value_a": 5,
              "value_b": 1,
              "position": {
                "x": -1.5,
                "y": -6.0,
                "orientation": "horizontal",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 5,
                "b": 1,
                "ndir": "left",
                "near_val": 1,
                "far_val": 5,
                "double": false,
                "center": [
                  -1.5,
                  -6.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1338,
              "value_a": 5,
              "value_b": 3,
              "position": {
                "x": -3.5,
                "y": -6.0,
                "orientation": "horizontal",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 5,
                "b": 3,
                "ndir": "left",
                "near_val": 5,
                "far_val": 3,
                "double": false,
                "center": [
                  -3.5,
                  -6.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1345,
              "value_a": 6,
              "value_b": 3,
              "position": {
                "x": 0.0,
                "y": 1.5,
                "orientation": "vertical",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 6,
                "b": 3,
                "ndir": "up",
                "near_val": 6,
                "far_val": 3,
                "double": false,
                "center": [
                  0.0,
                  1.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1323,
              "value_a": 3,
              "value_b": 2,
              "position": {
                "x": -5.5,
                "y": -6.0,
                "orientation": "horizontal",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 3,
                "b": 2,
                "ndir": "left",
                "near_val": 3,
                "far_val": 2,
                "double": false,
                "center": [
                  -5.5,
                  -6.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1331,
              "value_a": 4,
              "value_b": 3,
              "position": {
                "x": 0.0,
                "y": 3.5,
                "orientation": "vertical",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 4,
                "b": 3,
                "ndir": "up",
                "near_val": 3,
                "far_val": 4,
                "double": false,
                "center": [
                  0.0,
                  3.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1330,
              "value_a": 4,
              "value_b": 2,
              "position": {
                "x": -6.0,
                "y": -4.5,
                "orientation": "vertical",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 4,
                "b": 2,
                "ndir": "up",
                "near_val": 2,
                "far_val": 4,
                "double": false,
                "center": [
                  -6.0,
                  -4.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1328,
              "value_a": 4,
              "value_b": 0,
              "position": {
                "x": 0.0,
                "y": 5.5,
                "orientation": "vertical",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 4,
                "b": 0,
                "ndir": "up",
                "near_val": 4,
                "far_val": 0,
                "double": false,
                "center": [
                  0.0,
                  5.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1332,
              "value_a": 4,
              "value_b": 4,
              "position": {
                "x": -6.0,
                "y": -3.0,
                "orientation": "horizontal",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 4,
                "b": 4,
                "ndir": "up",
                "near_val": 4,
                "far_val": 4,
                "double": false,
                "center": [
                  -6.0,
                  -3.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1346,
              "value_a": 6,
              "value_b": 4,
              "position": {
                "x": -6.0,
                "y": -1.5,
                "orientation": "vertical",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 6,
                "b": 4,
                "ndir": "up",
                "near_val": 4,
                "far_val": 6,
                "double": false,
                "center": [
                  -6.0,
                  -1.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1300,
              "value_a": 0,
              "value_b": 0,
              "position": {
                "x": 1.5,
                "y": 6.0,
                "orientation": "horizontal",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 0,
                "b": 0,
                "ndir": "right",
                "near_val": 0,
                "far_val": 0,
                "double": false,
                "center": [
                  1.5,
                  6.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1307,
              "value_a": 1,
              "value_b": 0,
              "position": {
                "x": 3.5,
                "y": 6.0,
                "orientation": "horizontal",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 1,
                "b": 0,
                "ndir": "right",
                "near_val": 0,
                "far_val": 1,
                "double": false,
                "center": [
                  3.5,
                  6.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1344,
              "value_a": 6,
              "value_b": 2,
              "position": {
                "x": -6.0,
                "y": 0.5,
                "orientation": "vertical",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 6,
                "b": 2,
                "ndir": "up",
                "near_val": 6,
                "far_val": 2,
                "double": false,
                "center": [
                  -6.0,
                  0.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1329,
              "value_a": 4,
              "value_b": 1,
              "position": {
                "x": 5.5,
                "y": 6.0,
                "orientation": "horizontal",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 4,
                "b": 1,
                "ndir": "right",
                "near_val": 1,
                "far_val": 4,
                "double": false,
                "center": [
                  5.5,
                  6.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1316,
              "value_a": 2,
              "value_b": 2,
              "position": {
                "x": -6.0,
                "y": 2.0,
                "orientation": "horizontal",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 2,
                "b": 2,
                "ndir": "up",
                "near_val": 2,
                "far_val": 2,
                "double": false,
                "center": [
                  -6.0,
                  2.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1339,
              "value_a": 5,
              "value_b": 4,
              "position": {
                "x": 6.0,
                "y": 4.5,
                "orientation": "vertical",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 5,
                "b": 4,
                "ndir": "down",
                "near_val": 4,
                "far_val": 5,
                "double": false,
                "center": [
                  6.0,
                  4.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1337,
              "value_a": 5,
              "value_b": 2,
              "position": {
                "x": -6.0,
                "y": 3.5,
                "orientation": "vertical",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 5,
                "b": 2,
                "ndir": "up",
                "near_val": 2,
                "far_val": 5,
                "double": false,
                "center": [
                  -6.0,
                  3.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1335,
              "value_a": 5,
              "value_b": 0,
              "position": {
                "x": 6.0,
                "y": 2.5,
                "orientation": "vertical",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 5,
                "b": 0,
                "ndir": "down",
                "near_val": 5,
                "far_val": 0,
                "double": false,
                "center": [
                  6.0,
                  2.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1340,
              "value_a": 5,
              "value_b": 5,
              "position": {
                "x": -6.0,
                "y": 5.0,
                "orientation": "horizontal",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 5,
                "b": 5,
                "ndir": "up",
                "near_val": 5,
                "far_val": 5,
                "double": false,
                "center": [
                  -6.0,
                  5.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            }
          ],
          "board_ends": [],
          "chain_length": 22
        },
        "board_chain_length": 22,
        "players": [
          {
            "id": 101,
            "display_name": "You",
            "country_code": null,
            "avatar_key": null,
            "avatar_url": null,
            "is_bot": false,
            "team": 0,
            "position": 0
          },
          {
            "id": 102,
            "display_name": "Bot (Medium)",
            "country_code": null,
            "avatar_key": "avatar_1",
            "avatar_url": null,
            "is_bot": true,
            "team": 1,
            "position": 1
          },
          {
            "id": 103,
            "display_name": "Bot (Medium)",
            "country_code": null,
            "avatar_key": "avatar_2",
            "avatar_url": null,
            "is_bot": true,
            "team": 0,
            "position": 2
          },
          {
            "id": 104,
            "display_name": "Bot (Medium)",
            "country_code": null,
            "avatar_key": "avatar_3",
            "avatar_url": null,
            "is_bot": true,
            "team": 1,
            "position": 3
          }
        ],
        "hand_counts": {
          "0": 0,
          "1": 2,
          "2": 3,
          "3": 1
        },
        "next_round_ready": null,
        "next_game_id": null,
        "session_over": false,
        "session_winner_team": null,
        "session_completion_reason": null,
        "target_score": 100,
        "rematch": null
      },
      "team_scores": {
        "0": 21,
        "1": 0
      },
      "session_status": "active",
      "session_winner_team": null,
      "session_over": false,
      "target_score": 100,
      "rematch": null,
      "revealed_players": [
        {
          "position": 0,
          "user_id": 101,
          "display_name": "You",
          "is_bot": false,
          "country_code": null,
          "avatar_key": null,
          "tiles": []
        },
        {
          "position": 1,
          "user_id": 102,
          "display_name": "Bot (Medium)",
          "is_bot": true,
          "country_code": null,
          "avatar_key": "avatar_1",
          "tiles": [
            {
              "id": 1321,
              "value_a": 3,
              "value_b": 0
            },
            {
              "id": 1343,
              "value_a": 6,
              "value_b": 1
            }
          ]
        },
        {
          "position": 2,
          "user_id": 103,
          "display_name": "Bot (Medium)",
          "is_bot": true,
          "country_code": null,
          "avatar_key": "avatar_2",
          "tiles": [
            {
              "id": 1308,
              "value_a": 1,
              "value_b": 1
            },
            {
              "id": 1322,
              "value_a": 3,
              "value_b": 1
            },
            {
              "id": 1324,
              "value_a": 3,
              "value_b": 3
            }
          ]
        },
        {
          "position": 3,
          "user_id": 104,
          "display_name": "Bot (Medium)",
          "is_bot": true,
          "country_code": null,
          "avatar_key": "avatar_3",
          "tiles": [
            {
              "id": 1347,
              "value_a": 6,
              "value_b": 5
            }
          ]
        }
      ]
    }
  },
  "blocked": {
    "gameId": 9006,
    "boot": {
      "id": 9006,
      "state_seq": 23,
      "status": "active",
      "game_mode": "bots",
      "current_turn": 3,
      "current_turn_user_id": 104,
      "current_turn_team": 1,
      "board_left_end": 2,
      "board_right_end": 3,
      "played_tiles": [],
      "my_hand": [
        {
          "id": 1446,
          "value_a": 6,
          "value_b": 4,
          "is_double": false,
          "valid_positions": []
        }
      ],
      "my_team": 0,
      "my_position": 0,
      "viewer_cosmetics": {
        "table_skin": "green_fabric",
        "tile_skin": "classic"
      },
      "winner_team": null,
      "game_end_type": null,
      "session_id": 9002,
      "game_number": 1,
      "starting_player_position": 0,
      "starting_player_user_id": 101,
      "board_layout": {
        "board_config": {
          "min_x": -6,
          "max_x": 6,
          "min_y": -7,
          "max_y": 7,
          "tile_width": 2,
          "tile_height": 1
        },
        "tiles": [
          {
            "id": 1448,
            "value_a": 6,
            "value_b": 6,
            "position": {
              "x": 0.0,
              "y": 0.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 6,
              "ndir": "right",
              "near_val": 6,
              "far_val": 6,
              "double": false,
              "center": [
                0.0,
                0.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1444,
            "value_a": 6,
            "value_b": 2,
            "position": {
              "x": 0.0,
              "y": -1.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 2,
              "ndir": "down",
              "near_val": 6,
              "far_val": 2,
              "double": false,
              "center": [
                0.0,
                -1.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1442,
            "value_a": 6,
            "value_b": 0,
            "position": {
              "x": 0.0,
              "y": 1.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 0,
              "ndir": "up",
              "near_val": 6,
              "far_val": 0,
              "double": false,
              "center": [
                0.0,
                1.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1415,
            "value_a": 2,
            "value_b": 1,
            "position": {
              "x": 0.0,
              "y": -3.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 2,
              "b": 1,
              "ndir": "down",
              "near_val": 2,
              "far_val": 1,
              "double": false,
              "center": [
                0.0,
                -3.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1428,
            "value_a": 4,
            "value_b": 0,
            "position": {
              "x": 0.0,
              "y": 3.5,
              "orientation": "vertical",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 4,
              "b": 0,
              "ndir": "up",
              "near_val": 0,
              "far_val": 4,
              "double": false,
              "center": [
                0.0,
                3.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1422,
            "value_a": 3,
            "value_b": 1,
            "position": {
              "x": 0.0,
              "y": -5.5,
              "orientation": "vertical",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 3,
              "b": 1,
              "ndir": "down",
              "near_val": 1,
              "far_val": 3,
              "double": false,
              "center": [
                0.0,
                -5.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1439,
            "value_a": 5,
            "value_b": 4,
            "position": {
              "x": 0.0,
              "y": 5.5,
              "orientation": "vertical",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 5,
              "b": 4,
              "ndir": "up",
              "near_val": 4,
              "far_val": 5,
              "double": false,
              "center": [
                0.0,
                5.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1438,
            "value_a": 5,
            "value_b": 3,
            "position": {
              "x": -1.5,
              "y": -6.0,
              "orientation": "horizontal",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 5,
              "b": 3,
              "ndir": "left",
              "near_val": 3,
              "far_val": 5,
              "double": false,
              "center": [
                -1.5,
                -6.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1437,
            "value_a": 5,
            "value_b": 2,
            "position": {
              "x": 1.5,
              "y": 6.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 5,
              "b": 2,
              "ndir": "right",
              "near_val": 5,
              "far_val": 2,
              "double": false,
              "center": [
                1.5,
                6.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1436,
            "value_a": 5,
            "value_b": 1,
            "position": {
              "x": -3.5,
              "y": -6.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 5,
              "b": 1,
              "ndir": "left",
              "near_val": 5,
              "far_val": 1,
              "double": false,
              "center": [
                -3.5,
                -6.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1407,
            "value_a": 1,
            "value_b": 0,
            "position": {
              "x": -5.5,
              "y": -6.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 1,
              "b": 0,
              "ndir": "left",
              "near_val": 1,
              "far_val": 0,
              "double": false,
              "center": [
                -5.5,
                -6.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1414,
            "value_a": 2,
            "value_b": 0,
            "position": {
              "x": 3.5,
              "y": 6.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 2,
              "b": 0,
              "ndir": "right",
              "near_val": 2,
              "far_val": 0,
              "double": false,
              "center": [
                3.5,
                6.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1421,
            "value_a": 3,
            "value_b": 0,
            "position": {
              "x": -6.0,
              "y": -4.5,
              "orientation": "vertical",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 3,
              "b": 0,
              "ndir": "up",
              "near_val": 0,
              "far_val": 3,
              "double": false,
              "center": [
                -6.0,
                -4.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1400,
            "value_a": 0,
            "value_b": 0,
            "position": {
              "x": 5.0,
              "y": 6.0,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 0,
              "b": 0,
              "ndir": "right",
              "near_val": 0,
              "far_val": 0,
              "double": false,
              "center": [
                5.0,
                6.0
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1435,
            "value_a": 5,
            "value_b": 0,
            "position": {
              "x": 5.0,
              "y": 4.0,
              "orientation": "vertical",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 5,
              "b": 0,
              "ndir": "down",
              "near_val": 0,
              "far_val": 5,
              "double": false,
              "center": [
                5.0,
                4.0
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1431,
            "value_a": 4,
            "value_b": 3,
            "position": {
              "x": -6.0,
              "y": -2.5,
              "orientation": "vertical",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 4,
              "b": 3,
              "ndir": "up",
              "near_val": 3,
              "far_val": 4,
              "double": false,
              "center": [
                -6.0,
                -2.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1430,
            "value_a": 4,
            "value_b": 2,
            "position": {
              "x": -6.0,
              "y": -0.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 4,
              "b": 2,
              "ndir": "up",
              "near_val": 4,
              "far_val": 2,
              "double": false,
              "center": [
                -6.0,
                -0.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1416,
            "value_a": 2,
            "value_b": 2,
            "position": {
              "x": -6.0,
              "y": 1.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 2,
              "b": 2,
              "ndir": "up",
              "near_val": 2,
              "far_val": 2,
              "double": false,
              "center": [
                -6.0,
                1.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1447,
            "value_a": 6,
            "value_b": 5,
            "position": {
              "x": 5.0,
              "y": 2.0,
              "orientation": "vertical",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 5,
              "ndir": "down",
              "near_val": 5,
              "far_val": 6,
              "double": false,
              "center": [
                5.0,
                2.0
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1445,
            "value_a": 6,
            "value_b": 3,
            "position": {
              "x": 5.0,
              "y": 0.0,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 3,
              "ndir": "down",
              "near_val": 6,
              "far_val": 3,
              "double": false,
              "center": [
                5.0,
                0.0
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1424,
            "value_a": 3,
            "value_b": 3,
            "position": {
              "x": 5.0,
              "y": -1.5,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 3,
              "b": 3,
              "ndir": "down",
              "near_val": 3,
              "far_val": 3,
              "double": false,
              "center": [
                5.0,
                -1.5
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          }
        ],
        "board_ends": [],
        "chain_length": 21
      },
      "board_chain_length": 21,
      "players": [
        {
          "id": 101,
          "display_name": "You",
          "country_code": null,
          "avatar_key": null,
          "avatar_url": null,
          "is_bot": false,
          "team": 0,
          "position": 0
        },
        {
          "id": 102,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_1",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 1
        },
        {
          "id": 103,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_2",
          "avatar_url": null,
          "is_bot": true,
          "team": 0,
          "position": 2
        },
        {
          "id": 104,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_3",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 3
        }
      ],
      "hand_counts": {
        "0": 1,
        "1": 2,
        "2": 2,
        "3": 2
      },
      "session_team_scores": {
        "0": 0,
        "1": 0
      },
      "next_round_ready": null,
      "next_game_id": null,
      "session_over": false,
      "session_winner_team": null,
      "session_completion_reason": null,
      "target_score": 100,
      "rematch": null
    },
    "finished": {
      "game_state": {
        "id": 9006,
        "state_seq": 24,
        "status": "finished",
        "game_mode": "bots",
        "current_turn": 3,
        "current_turn_user_id": 104,
        "current_turn_team": 1,
        "board_left_end": 3,
        "board_right_end": 3,
        "played_tiles": [],
        "winner_team": 1,
        "game_end_type": "blocked",
        "session_id": 9002,
        "game_number": 1,
        "starting_player_position": 0,
        "starting_player_user_id": 101,
        "board_layout": {
          "board_config": {
            "min_x": -6,
            "max_x": 6,
            "min_y": -7,
            "max_y": 7,
            "tile_width": 2,
            "tile_height": 1
          },
          "tiles": [
            {
              "id": 1448,
              "value_a": 6,
              "value_b": 6,
              "position": {
                "x": 0.0,
                "y": 0.0,
                "orientation": "horizontal",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 6,
                "b": 6,
                "ndir": "right",
                "near_val": 6,
                "far_val": 6,
                "double": false,
                "center": [
                  0.0,
                  0.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1444,
              "value_a": 6,
              "value_b": 2,
              "position": {
                "x": 0.0,
                "y": -1.5,
                "orientation": "vertical",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 6,
                "b": 2,
                "ndir": "down",
                "near_val": 6,
                "far_val": 2,
                "double": false,
                "center": [
                  0.0,
                  -1.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1442,
              "value_a": 6,
              "value_b": 0,
              "position": {
                "x": 0.0,
                "y": 1.5,
                "orientation": "vertical",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 6,
                "b": 0,
                "ndir": "up",
                "near_val": 6,
                "far_val": 0,
                "double": false,
                "center": [
                  0.0,
                  1.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1415,
              "value_a": 2,
              "value_b": 1,
              "position": {
                "x": 0.0,
                "y": -3.5,
                "orientation": "vertical",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 2,
                "b": 1,
                "ndir": "down",
                "near_val": 2,
                "far_val": 1,
                "double": false,
                "center": [
                  0.0,
                  -3.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1428,
              "value_a": 4,
              "value_b": 0,
              "position": {
                "x": 0.0,
                "y": 3.5,
                "orientation": "vertical",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 4,
                "b": 0,
                "ndir": "up",
                "near_val": 0,
                "far_val": 4,
                "double": false,
                "center": [
                  0.0,
                  3.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1422,
              "value_a": 3,
              "value_b": 1,
              "position": {
                "x": 0.0,
                "y": -5.5,
                "orientation": "vertical",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 3,
                "b": 1,
                "ndir": "down",
                "near_val": 1,
                "far_val": 3,
                "double": false,
                "center": [
                  0.0,
                  -5.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1439,
              "value_a": 5,
              "value_b": 4,
              "position": {
                "x": 0.0,
                "y": 5.5,
                "orientation": "vertical",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 5,
                "b": 4,
                "ndir": "up",
                "near_val": 4,
                "far_val": 5,
                "double": false,
                "center": [
                  0.0,
                  5.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1438,
              "value_a": 5,
              "value_b": 3,
              "position": {
                "x": -1.5,
                "y": -6.0,
                "orientation": "horizontal",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 5,
                "b": 3,
                "ndir": "left",
                "near_val": 3,
                "far_val": 5,
                "double": false,
                "center": [
                  -1.5,
                  -6.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1437,
              "value_a": 5,
              "value_b": 2,
              "position": {
                "x": 1.5,
                "y": 6.0,
                "orientation": "horizontal",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 5,
                "b": 2,
                "ndir": "right",
                "near_val": 5,
                "far_val": 2,
                "double": false,
                "center": [
                  1.5,
                  6.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1436,
              "value_a": 5,
              "value_b": 1,
              "position": {
                "x": -3.5,
                "y": -6.0,
                "orientation": "horizontal",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 5,
                "b": 1,
                "ndir": "left",
                "near_val": 5,
                "far_val": 1,
                "double": false,
                "center": [
                  -3.5,
                  -6.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1407,
              "value_a": 1,
              "value_b": 0,
              "position": {
                "x": -5.5,
                "y": -6.0,
                "orientation": "horizontal",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 1,
                "b": 0,
                "ndir": "left",
                "near_val": 1,
                "far_val": 0,
                "double": false,
                "center": [
                  -5.5,
                  -6.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1414,
              "value_a": 2,
              "value_b": 0,
              "position": {
                "x": 3.5,
                "y": 6.0,
                "orientation": "horizontal",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 2,
                "b": 0,
                "ndir": "right",
                "near_val": 2,
                "far_val": 0,
                "double": false,
                "center": [
                  3.5,
                  6.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1421,
              "value_a": 3,
              "value_b": 0,
              "position": {
                "x": -6.0,
                "y": -4.5,
                "orientation": "vertical",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 3,
                "b": 0,
                "ndir": "up",
                "near_val": 0,
                "far_val": 3,
                "double": false,
                "center": [
                  -6.0,
                  -4.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1400,
              "value_a": 0,
              "value_b": 0,
              "position": {
                "x": 5.0,
                "y": 6.0,
                "orientation": "vertical",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 0,
                "b": 0,
                "ndir": "right",
                "near_val": 0,
                "far_val": 0,
                "double": false,
                "center": [
                  5.0,
                  6.0
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1435,
              "value_a": 5,
              "value_b": 0,
              "position": {
                "x": 5.0,
                "y": 4.0,
                "orientation": "vertical",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 5,
                "b": 0,
                "ndir": "down",
                "near_val": 0,
                "far_val": 5,
                "double": false,
                "center": [
                  5.0,
                  4.0
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1431,
              "value_a": 4,
              "value_b": 3,
              "position": {
                "x": -6.0,
                "y": -2.5,
                "orientation": "vertical",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 4,
                "b": 3,
                "ndir": "up",
                "near_val": 3,
                "far_val": 4,
                "double": false,
                "center": [
                  -6.0,
                  -2.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1430,
              "value_a": 4,
              "value_b": 2,
              "position": {
                "x": -6.0,
                "y": -0.5,
                "orientation": "vertical",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 4,
                "b": 2,
                "ndir": "up",
                "near_val": 4,
                "far_val": 2,
                "double": false,
                "center": [
                  -6.0,
                  -0.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1416,
              "value_a": 2,
              "value_b": 2,
              "position": {
                "x": -6.0,
                "y": 1.0,
                "orientation": "horizontal",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 2,
                "b": 2,
                "ndir": "up",
                "near_val": 2,
                "far_val": 2,
                "double": false,
                "center": [
                  -6.0,
                  1.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1447,
              "value_a": 6,
              "value_b": 5,
              "position": {
                "x": 5.0,
                "y": 2.0,
                "orientation": "vertical",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 6,
                "b": 5,
                "ndir": "down",
                "near_val": 5,
                "far_val": 6,
                "double": false,
                "center": [
                  5.0,
                  2.0
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1445,
              "value_a": 6,
              "value_b": 3,
              "position": {
                "x": 5.0,
                "y": 0.0,
                "orientation": "vertical",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 6,
                "b": 3,
                "ndir": "down",
                "near_val": 6,
                "far_val": 3,
                "double": false,
                "center": [
                  5.0,
                  0.0
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1424,
              "value_a": 3,
              "value_b": 3,
              "position": {
                "x": 5.0,
                "y": -1.5,
                "orientation": "horizontal",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 3,
                "b": 3,
                "ndir": "down",
                "near_val": 3,
                "far_val": 3,
                "double": false,
                "center": [
                  5.0,
                  -1.5
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1423,
              "value_a": 3,
              "value_b": 2,
              "position": {
                "x": -6.0,
                "y": 2.5,
                "orientation": "vertical",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 3,
                "b": 2,
                "ndir": "up",
                "near_val": 2,
                "far_val": 3,
                "double": false,
                "center": [
                  -6.0,
                  2.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            }
          ],
          "board_ends": [],
          "chain_length": 22
        },
        "board_chain_length": 22,
        "players": [
          {
            "id": 101,
            "display_name": "You",
            "country_code": null,
            "avatar_key": null,
            "avatar_url": null,
            "is_bot": false,
            "team": 0,
            "position": 0
          },
          {
            "id": 102,
            "display_name": "Bot (Medium)",
            "country_code": null,
            "avatar_key": "avatar_1",
            "avatar_url": null,
            "is_bot": true,
            "team": 1,
            "position": 1
          },
          {
            "id": 103,
            "display_name": "Bot (Medium)",
            "country_code": null,
            "avatar_key": "avatar_2",
            "avatar_url": null,
            "is_bot": true,
            "team": 0,
            "position": 2
          },
          {
            "id": 104,
            "display_name": "Bot (Medium)",
            "country_code": null,
            "avatar_key": "avatar_3",
            "avatar_url": null,
            "is_bot": true,
            "team": 1,
            "position": 3
          }
        ],
        "hand_counts": {
          "0": 1,
          "1": 2,
          "2": 2,
          "3": 1
        },
        "next_round_ready": null,
        "next_game_id": null,
        "session_over": false,
        "session_winner_team": null,
        "session_completion_reason": null,
        "target_score": 100,
        "rematch": null
      },
      "team_scores": {
        "0": 0,
        "1": 28
      },
      "session_status": "active",
      "session_winner_team": null,
      "session_over": false,
      "target_score": 100,
      "rematch": null,
      "revealed_players": [
        {
          "position": 0,
          "user_id": 101,
          "display_name": "You",
          "is_bot": false,
          "country_code": null,
          "avatar_key": null,
          "tiles": [
            {
              "id": 1446,
              "value_a": 6,
              "value_b": 4
            }
          ]
        },
        {
          "position": 1,
          "user_id": 102,
          "display_name": "Bot (Medium)",
          "is_bot": true,
          "country_code": null,
          "avatar_key": "avatar_1",
          "tiles": [
            {
              "id": 1408,
              "value_a": 1,
              "value_b": 1
            },
            {
              "id": 1443,
              "value_a": 6,
              "value_b": 1
            }
          ]
        },
        {
          "position": 2,
          "user_id": 103,
          "display_name": "Bot (Medium)",
          "is_bot": true,
          "country_code": null,
          "avatar_key": "avatar_2",
          "tiles": [
            {
              "id": 1432,
              "value_a": 4,
              "value_b": 4
            },
            {
              "id": 1440,
              "value_a": 5,
              "value_b": 5
            }
          ]
        },
        {
          "position": 3,
          "user_id": 104,
          "display_name": "Bot (Medium)",
          "is_bot": true,
          "country_code": null,
          "avatar_key": "avatar_3",
          "tiles": [
            {
              "id": 1429,
              "value_a": 4,
              "value_b": 1
            }
          ]
        }
      ]
    }
  },
  "matchwin": {
    "gameId": 9007,
    "boot": {
      "id": 9007,
      "state_seq": 24,
      "status": "active",
      "game_mode": "bots",
      "current_turn": 0,
      "current_turn_user_id": 101,
      "current_turn_team": 0,
      "board_left_end": 5,
      "board_right_end": 0,
      "played_tiles": [],
      "my_hand": [
        {
          "id": 1540,
          "value_a": 5,
          "value_b": 5,
          "is_double": true,
          "valid_positions": [
            {
              "side": "left",
              "end_id": 22,
              "x": -6.0,
              "y": 5.0,
              "orientation": "horizontal",
              "engine_data": {
                "a": 5,
                "b": 5,
                "ndir": "up",
                "near_val": 5,
                "far_val": 5,
                "double": true,
                "center": [
                  -6.0,
                  5.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            }
          ]
        }
      ],
      "my_team": 0,
      "my_position": 0,
      "viewer_cosmetics": {
        "table_skin": "green_fabric",
        "tile_skin": "classic"
      },
      "winner_team": null,
      "game_end_type": null,
      "session_id": 9002,
      "game_number": 1,
      "starting_player_position": 0,
      "starting_player_user_id": 101,
      "board_layout": {
        "board_config": {
          "min_x": -6,
          "max_x": 6,
          "min_y": -7,
          "max_y": 7,
          "tile_width": 2,
          "tile_height": 1
        },
        "tiles": [
          {
            "id": 1548,
            "value_a": 6,
            "value_b": 6,
            "position": {
              "x": 0.0,
              "y": 0.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 6,
              "ndir": "right",
              "near_val": 6,
              "far_val": 6,
              "double": false,
              "center": [
                0.0,
                0.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1542,
            "value_a": 6,
            "value_b": 0,
            "position": {
              "x": 0.0,
              "y": -1.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 0,
              "ndir": "down",
              "near_val": 6,
              "far_val": 0,
              "double": false,
              "center": [
                0.0,
                -1.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1514,
            "value_a": 2,
            "value_b": 0,
            "position": {
              "x": 0.0,
              "y": -3.5,
              "orientation": "vertical",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 2,
              "b": 0,
              "ndir": "down",
              "near_val": 0,
              "far_val": 2,
              "double": false,
              "center": [
                0.0,
                -3.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1515,
            "value_a": 2,
            "value_b": 1,
            "position": {
              "x": 0.0,
              "y": -5.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 2,
              "b": 1,
              "ndir": "down",
              "near_val": 2,
              "far_val": 1,
              "double": false,
              "center": [
                0.0,
                -5.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1536,
            "value_a": 5,
            "value_b": 1,
            "position": {
              "x": -1.5,
              "y": -6.0,
              "orientation": "horizontal",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 5,
              "b": 1,
              "ndir": "left",
              "near_val": 1,
              "far_val": 5,
              "double": false,
              "center": [
                -1.5,
                -6.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1538,
            "value_a": 5,
            "value_b": 3,
            "position": {
              "x": -3.5,
              "y": -6.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 5,
              "b": 3,
              "ndir": "left",
              "near_val": 5,
              "far_val": 3,
              "double": false,
              "center": [
                -3.5,
                -6.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1545,
            "value_a": 6,
            "value_b": 3,
            "position": {
              "x": 0.0,
              "y": 1.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 3,
              "ndir": "up",
              "near_val": 6,
              "far_val": 3,
              "double": false,
              "center": [
                0.0,
                1.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1523,
            "value_a": 3,
            "value_b": 2,
            "position": {
              "x": -5.5,
              "y": -6.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 3,
              "b": 2,
              "ndir": "left",
              "near_val": 3,
              "far_val": 2,
              "double": false,
              "center": [
                -5.5,
                -6.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1531,
            "value_a": 4,
            "value_b": 3,
            "position": {
              "x": 0.0,
              "y": 3.5,
              "orientation": "vertical",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 4,
              "b": 3,
              "ndir": "up",
              "near_val": 3,
              "far_val": 4,
              "double": false,
              "center": [
                0.0,
                3.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1530,
            "value_a": 4,
            "value_b": 2,
            "position": {
              "x": -6.0,
              "y": -4.5,
              "orientation": "vertical",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 4,
              "b": 2,
              "ndir": "up",
              "near_val": 2,
              "far_val": 4,
              "double": false,
              "center": [
                -6.0,
                -4.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1528,
            "value_a": 4,
            "value_b": 0,
            "position": {
              "x": 0.0,
              "y": 5.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 4,
              "b": 0,
              "ndir": "up",
              "near_val": 4,
              "far_val": 0,
              "double": false,
              "center": [
                0.0,
                5.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1532,
            "value_a": 4,
            "value_b": 4,
            "position": {
              "x": -6.0,
              "y": -3.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 4,
              "b": 4,
              "ndir": "up",
              "near_val": 4,
              "far_val": 4,
              "double": false,
              "center": [
                -6.0,
                -3.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1546,
            "value_a": 6,
            "value_b": 4,
            "position": {
              "x": -6.0,
              "y": -1.5,
              "orientation": "vertical",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 4,
              "ndir": "up",
              "near_val": 4,
              "far_val": 6,
              "double": false,
              "center": [
                -6.0,
                -1.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1500,
            "value_a": 0,
            "value_b": 0,
            "position": {
              "x": 1.5,
              "y": 6.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 0,
              "b": 0,
              "ndir": "right",
              "near_val": 0,
              "far_val": 0,
              "double": false,
              "center": [
                1.5,
                6.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1507,
            "value_a": 1,
            "value_b": 0,
            "position": {
              "x": 3.5,
              "y": 6.0,
              "orientation": "horizontal",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 1,
              "b": 0,
              "ndir": "right",
              "near_val": 0,
              "far_val": 1,
              "double": false,
              "center": [
                3.5,
                6.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1544,
            "value_a": 6,
            "value_b": 2,
            "position": {
              "x": -6.0,
              "y": 0.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 6,
              "b": 2,
              "ndir": "up",
              "near_val": 6,
              "far_val": 2,
              "double": false,
              "center": [
                -6.0,
                0.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1529,
            "value_a": 4,
            "value_b": 1,
            "position": {
              "x": 5.5,
              "y": 6.0,
              "orientation": "horizontal",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 4,
              "b": 1,
              "ndir": "right",
              "near_val": 1,
              "far_val": 4,
              "double": false,
              "center": [
                5.5,
                6.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1516,
            "value_a": 2,
            "value_b": 2,
            "position": {
              "x": -6.0,
              "y": 2.0,
              "orientation": "horizontal",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 2,
              "b": 2,
              "ndir": "up",
              "near_val": 2,
              "far_val": 2,
              "double": false,
              "center": [
                -6.0,
                2.0
              ],
              "horizontal": true,
              "cross_horizontal": false
            }
          },
          {
            "id": 1539,
            "value_a": 5,
            "value_b": 4,
            "position": {
              "x": 6.0,
              "y": 4.5,
              "orientation": "vertical",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 5,
              "b": 4,
              "ndir": "down",
              "near_val": 4,
              "far_val": 5,
              "double": false,
              "center": [
                6.0,
                4.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1537,
            "value_a": 5,
            "value_b": 2,
            "position": {
              "x": -6.0,
              "y": 3.5,
              "orientation": "vertical",
              "connected_side": "b"
            },
            "connected_side": "b",
            "is_double": false,
            "engine_data": {
              "a": 5,
              "b": 2,
              "ndir": "up",
              "near_val": 2,
              "far_val": 5,
              "double": false,
              "center": [
                -6.0,
                3.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          },
          {
            "id": 1535,
            "value_a": 5,
            "value_b": 0,
            "position": {
              "x": 6.0,
              "y": 2.5,
              "orientation": "vertical",
              "connected_side": "a"
            },
            "connected_side": "a",
            "is_double": false,
            "engine_data": {
              "a": 5,
              "b": 0,
              "ndir": "down",
              "near_val": 5,
              "far_val": 0,
              "double": false,
              "center": [
                6.0,
                2.5
              ],
              "horizontal": false,
              "cross_horizontal": false
            }
          }
        ],
        "board_ends": [],
        "chain_length": 21
      },
      "board_chain_length": 21,
      "players": [
        {
          "id": 101,
          "display_name": "You",
          "country_code": null,
          "avatar_key": null,
          "avatar_url": null,
          "is_bot": false,
          "team": 0,
          "position": 0
        },
        {
          "id": 102,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_1",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 1
        },
        {
          "id": 103,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_2",
          "avatar_url": null,
          "is_bot": true,
          "team": 0,
          "position": 2
        },
        {
          "id": 104,
          "display_name": "Bot (Medium)",
          "country_code": null,
          "avatar_key": "avatar_3",
          "avatar_url": null,
          "is_bot": true,
          "team": 1,
          "position": 3
        }
      ],
      "hand_counts": {
        "0": 1,
        "1": 2,
        "2": 3,
        "3": 1
      },
      "session_team_scores": {
        "0": 95,
        "1": 88
      },
      "next_round_ready": null,
      "next_game_id": null,
      "session_over": false,
      "session_winner_team": null,
      "session_completion_reason": null,
      "target_score": 100,
      "rematch": null
    },
    "finished": {
      "game_state": {
        "id": 9007,
        "state_seq": 25,
        "status": "finished",
        "game_mode": "bots",
        "current_turn": 0,
        "current_turn_user_id": 101,
        "current_turn_team": 0,
        "board_left_end": 5,
        "board_right_end": 0,
        "played_tiles": [],
        "winner_team": 0,
        "game_end_type": "win",
        "session_id": 9002,
        "game_number": 1,
        "starting_player_position": 0,
        "starting_player_user_id": 101,
        "board_layout": {
          "board_config": {
            "min_x": -6,
            "max_x": 6,
            "min_y": -7,
            "max_y": 7,
            "tile_width": 2,
            "tile_height": 1
          },
          "tiles": [
            {
              "id": 1548,
              "value_a": 6,
              "value_b": 6,
              "position": {
                "x": 0.0,
                "y": 0.0,
                "orientation": "horizontal",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 6,
                "b": 6,
                "ndir": "right",
                "near_val": 6,
                "far_val": 6,
                "double": false,
                "center": [
                  0.0,
                  0.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1542,
              "value_a": 6,
              "value_b": 0,
              "position": {
                "x": 0.0,
                "y": -1.5,
                "orientation": "vertical",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 6,
                "b": 0,
                "ndir": "down",
                "near_val": 6,
                "far_val": 0,
                "double": false,
                "center": [
                  0.0,
                  -1.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1514,
              "value_a": 2,
              "value_b": 0,
              "position": {
                "x": 0.0,
                "y": -3.5,
                "orientation": "vertical",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 2,
                "b": 0,
                "ndir": "down",
                "near_val": 0,
                "far_val": 2,
                "double": false,
                "center": [
                  0.0,
                  -3.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1515,
              "value_a": 2,
              "value_b": 1,
              "position": {
                "x": 0.0,
                "y": -5.5,
                "orientation": "vertical",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 2,
                "b": 1,
                "ndir": "down",
                "near_val": 2,
                "far_val": 1,
                "double": false,
                "center": [
                  0.0,
                  -5.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1536,
              "value_a": 5,
              "value_b": 1,
              "position": {
                "x": -1.5,
                "y": -6.0,
                "orientation": "horizontal",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 5,
                "b": 1,
                "ndir": "left",
                "near_val": 1,
                "far_val": 5,
                "double": false,
                "center": [
                  -1.5,
                  -6.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1538,
              "value_a": 5,
              "value_b": 3,
              "position": {
                "x": -3.5,
                "y": -6.0,
                "orientation": "horizontal",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 5,
                "b": 3,
                "ndir": "left",
                "near_val": 5,
                "far_val": 3,
                "double": false,
                "center": [
                  -3.5,
                  -6.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1545,
              "value_a": 6,
              "value_b": 3,
              "position": {
                "x": 0.0,
                "y": 1.5,
                "orientation": "vertical",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 6,
                "b": 3,
                "ndir": "up",
                "near_val": 6,
                "far_val": 3,
                "double": false,
                "center": [
                  0.0,
                  1.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1523,
              "value_a": 3,
              "value_b": 2,
              "position": {
                "x": -5.5,
                "y": -6.0,
                "orientation": "horizontal",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 3,
                "b": 2,
                "ndir": "left",
                "near_val": 3,
                "far_val": 2,
                "double": false,
                "center": [
                  -5.5,
                  -6.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1531,
              "value_a": 4,
              "value_b": 3,
              "position": {
                "x": 0.0,
                "y": 3.5,
                "orientation": "vertical",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 4,
                "b": 3,
                "ndir": "up",
                "near_val": 3,
                "far_val": 4,
                "double": false,
                "center": [
                  0.0,
                  3.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1530,
              "value_a": 4,
              "value_b": 2,
              "position": {
                "x": -6.0,
                "y": -4.5,
                "orientation": "vertical",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 4,
                "b": 2,
                "ndir": "up",
                "near_val": 2,
                "far_val": 4,
                "double": false,
                "center": [
                  -6.0,
                  -4.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1528,
              "value_a": 4,
              "value_b": 0,
              "position": {
                "x": 0.0,
                "y": 5.5,
                "orientation": "vertical",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 4,
                "b": 0,
                "ndir": "up",
                "near_val": 4,
                "far_val": 0,
                "double": false,
                "center": [
                  0.0,
                  5.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1532,
              "value_a": 4,
              "value_b": 4,
              "position": {
                "x": -6.0,
                "y": -3.0,
                "orientation": "horizontal",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 4,
                "b": 4,
                "ndir": "up",
                "near_val": 4,
                "far_val": 4,
                "double": false,
                "center": [
                  -6.0,
                  -3.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1546,
              "value_a": 6,
              "value_b": 4,
              "position": {
                "x": -6.0,
                "y": -1.5,
                "orientation": "vertical",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 6,
                "b": 4,
                "ndir": "up",
                "near_val": 4,
                "far_val": 6,
                "double": false,
                "center": [
                  -6.0,
                  -1.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1500,
              "value_a": 0,
              "value_b": 0,
              "position": {
                "x": 1.5,
                "y": 6.0,
                "orientation": "horizontal",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 0,
                "b": 0,
                "ndir": "right",
                "near_val": 0,
                "far_val": 0,
                "double": false,
                "center": [
                  1.5,
                  6.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1507,
              "value_a": 1,
              "value_b": 0,
              "position": {
                "x": 3.5,
                "y": 6.0,
                "orientation": "horizontal",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 1,
                "b": 0,
                "ndir": "right",
                "near_val": 0,
                "far_val": 1,
                "double": false,
                "center": [
                  3.5,
                  6.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1544,
              "value_a": 6,
              "value_b": 2,
              "position": {
                "x": -6.0,
                "y": 0.5,
                "orientation": "vertical",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 6,
                "b": 2,
                "ndir": "up",
                "near_val": 6,
                "far_val": 2,
                "double": false,
                "center": [
                  -6.0,
                  0.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1529,
              "value_a": 4,
              "value_b": 1,
              "position": {
                "x": 5.5,
                "y": 6.0,
                "orientation": "horizontal",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 4,
                "b": 1,
                "ndir": "right",
                "near_val": 1,
                "far_val": 4,
                "double": false,
                "center": [
                  5.5,
                  6.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1516,
              "value_a": 2,
              "value_b": 2,
              "position": {
                "x": -6.0,
                "y": 2.0,
                "orientation": "horizontal",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 2,
                "b": 2,
                "ndir": "up",
                "near_val": 2,
                "far_val": 2,
                "double": false,
                "center": [
                  -6.0,
                  2.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            },
            {
              "id": 1539,
              "value_a": 5,
              "value_b": 4,
              "position": {
                "x": 6.0,
                "y": 4.5,
                "orientation": "vertical",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 5,
                "b": 4,
                "ndir": "down",
                "near_val": 4,
                "far_val": 5,
                "double": false,
                "center": [
                  6.0,
                  4.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1537,
              "value_a": 5,
              "value_b": 2,
              "position": {
                "x": -6.0,
                "y": 3.5,
                "orientation": "vertical",
                "connected_side": "b"
              },
              "connected_side": "b",
              "is_double": false,
              "engine_data": {
                "a": 5,
                "b": 2,
                "ndir": "up",
                "near_val": 2,
                "far_val": 5,
                "double": false,
                "center": [
                  -6.0,
                  3.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1535,
              "value_a": 5,
              "value_b": 0,
              "position": {
                "x": 6.0,
                "y": 2.5,
                "orientation": "vertical",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 5,
                "b": 0,
                "ndir": "down",
                "near_val": 5,
                "far_val": 0,
                "double": false,
                "center": [
                  6.0,
                  2.5
                ],
                "horizontal": false,
                "cross_horizontal": false
              }
            },
            {
              "id": 1540,
              "value_a": 5,
              "value_b": 5,
              "position": {
                "x": -6.0,
                "y": 5.0,
                "orientation": "horizontal",
                "connected_side": "a"
              },
              "connected_side": "a",
              "is_double": false,
              "engine_data": {
                "a": 5,
                "b": 5,
                "ndir": "up",
                "near_val": 5,
                "far_val": 5,
                "double": false,
                "center": [
                  -6.0,
                  5.0
                ],
                "horizontal": true,
                "cross_horizontal": false
              }
            }
          ],
          "board_ends": [],
          "chain_length": 22
        },
        "board_chain_length": 22,
        "players": [
          {
            "id": 101,
            "display_name": "You",
            "country_code": null,
            "avatar_key": null,
            "avatar_url": null,
            "is_bot": false,
            "team": 0,
            "position": 0
          },
          {
            "id": 102,
            "display_name": "Bot (Medium)",
            "country_code": null,
            "avatar_key": "avatar_1",
            "avatar_url": null,
            "is_bot": true,
            "team": 1,
            "position": 1
          },
          {
            "id": 103,
            "display_name": "Bot (Medium)",
            "country_code": null,
            "avatar_key": "avatar_2",
            "avatar_url": null,
            "is_bot": true,
            "team": 0,
            "position": 2
          },
          {
            "id": 104,
            "display_name": "Bot (Medium)",
            "country_code": null,
            "avatar_key": "avatar_3",
            "avatar_url": null,
            "is_bot": true,
            "team": 1,
            "position": 3
          }
        ],
        "hand_counts": {
          "0": 0,
          "1": 2,
          "2": 3,
          "3": 1
        },
        "next_round_ready": null,
        "next_game_id": null,
        "session_over": true,
        "session_winner_team": 0,
        "session_completion_reason": "completed",
        "target_score": 100,
        "rematch": {
          "state": "pending",
          "votes": {},
          "required_human_count": 1,
          "yes_count": 0,
          "no_count": 0,
          "new_session_id": null,
          "new_game_id": null
        }
      },
      "team_scores": {
        "0": 116,
        "1": 88
      },
      "session_status": "finished",
      "session_winner_team": 0,
      "session_over": true,
      "target_score": 100,
      "rematch": {
        "state": "pending",
        "votes": {},
        "required_human_count": 1,
        "yes_count": 0,
        "no_count": 0,
        "new_session_id": null,
        "new_game_id": null
      },
      "revealed_players": [
        {
          "position": 0,
          "user_id": 101,
          "display_name": "You",
          "is_bot": false,
          "country_code": null,
          "avatar_key": null,
          "tiles": []
        },
        {
          "position": 1,
          "user_id": 102,
          "display_name": "Bot (Medium)",
          "is_bot": true,
          "country_code": null,
          "avatar_key": "avatar_1",
          "tiles": [
            {
              "id": 1521,
              "value_a": 3,
              "value_b": 0
            },
            {
              "id": 1543,
              "value_a": 6,
              "value_b": 1
            }
          ]
        },
        {
          "position": 2,
          "user_id": 103,
          "display_name": "Bot (Medium)",
          "is_bot": true,
          "country_code": null,
          "avatar_key": "avatar_2",
          "tiles": [
            {
              "id": 1508,
              "value_a": 1,
              "value_b": 1
            },
            {
              "id": 1522,
              "value_a": 3,
              "value_b": 1
            },
            {
              "id": 1524,
              "value_a": 3,
              "value_b": 3
            }
          ]
        },
        {
          "position": 3,
          "user_id": 104,
          "display_name": "Bot (Medium)",
          "is_bot": true,
          "country_code": null,
          "avatar_key": "avatar_3",
          "tiles": [
            {
              "id": 1547,
              "value_a": 6,
              "value_b": 5
            }
          ]
        }
      ]
    }
  }
};

/** Pip sum of a revealed hand (worked scoring examples derive from real data). */
export const revealedPipSum = (players: RevealedPlayer[], team: number): number =>
  players
    .filter((p) => p.position % 2 === team)
    .reduce((sum, p) => sum + p.tiles.reduce((s, t) => s + t.value_a + t.value_b, 0), 0);
